import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';
import { LoggerService } from '../shared/logger/logger.service';
import { take } from 'rxjs/operators';

/**
 * This service is used to check if user is allowed to navigate to certain route.
 */
@Injectable()
export class LoggedInGuard implements CanActivate {

  /**
   * Default constructor
   * @param {AuthService} auth
   * @param {LoggerService} logger
   */
  constructor(private auth: AuthService, private logger: LoggerService) {
  }

  /**
   * Checker function for valid access token and permissions.
   * @returns {Promise<boolean>|boolean} - authenticated true/false
   */
  /**
   *
   */
  canActivate() {
    const status = this.auth.getStatus();
    if(status === 'logging_in' || status === 'init') {
      return this.waitForLogin();
    } else if(status === 'logged_in') {
      this.logger.info('Authenticated, access allowed.');
      return true;
    }

    this.logger.info('Not authenticated, access not allowed!');
    this.auth.login();
    // redirect should happen here
    return false;
  }

  private waitForLogin(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.auth.login$.pipe(take(1)).subscribe({
        next() {
          resolve(true);
        },
        error(err) {
          reject(err);
        }
      });
    });
  }
}
